import { jsx } from 'react/jsx-runtime';

const SelectListNoItems = ({ children, ...props })=>{
    return jsx("div", {
        className: "select-list-no-items",
        ...props,
        children: children
    });
};
SelectListNoItems.displayName = 'SelectList.NoItems';

export { SelectListNoItems };
//# sourceMappingURL=SelectList.NoItems.es.js.map
